<template>
  <div class="col-sm-12 col-lg-auto sign-box">
    <div v-if="error" class="login-alert p-3 text-center mb-3">
      <div class="text-primary">{{ error.error }}</div>
      <span>{{ error.msg }}</span>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="mb-3 fw-bold">
          Для подписания анкеты лизингополучателя вручную необходимо:
        </div>

        <ul>
          <li>Распечатать и подписать документ от руки</li>
          <li>Отсканировать или сфотографировать подписанный документ</li>
          <li>Загрузить файл скана на сайт</li>
        </ul>
      </div>
    </div>

    <input
      type="file"
      multiple
      @change="handleFiles"
      ref="fileInput"
      style="display: none"
    />

    <div v-if="files.length" class="mb-3">
      <div class="row mb-1" v-for="(file, index) in files" :key="index">
        <div class="col-auto pe-1">
          <button
            @click="removeFile(index)"
            :disabled="loading"
            class="btn btn-ghost btn-small"
          >
            Удалить
          </button>
        </div>

        <div class="col sign-clip">
          {{ file.name }}
        </div>

        <div class="col-auto ps-1">
          <span class="fw-bold">{{ formatSize(file.size) }}</span>
        </div>
      </div>

      <div class="mt-3">
        Общий размер:
        <span class="fw-bold">{{ formatSize(totalSize) }}</span> / 10 MB
      </div>
    </div>

    <div v-if="errorSize" class="login-alert p-3 text-center mb-3">
      <span>{{ errorSize }}</span>
    </div>

    <div v-if="files.length > 0" class="d-flex flex-wrap gap-2">
      <ui-button
        @click="send"
        class="btn-base"
        :loading="loading"
        :disabled="totalSize > maxSize || loading"
      >
        Отправить
      </ui-button>

      <ui-button
        class="btn-ghost"
        @click="fileInput.click()"
        :disabled="totalSize > maxSize || loading"
        >Загрузить еще</ui-button
      >
    </div>

    <div v-else class="d-flex flex-wrap gap-2">
      <ui-button @click="getPrint" class="btn-ghost" :loading="loading"
        ><i class="icon-print me-2"></i> Распечатать</ui-button
      >

      <ui-button class="btn-base" @click="fileInput.click()"
        >Загрузить скан с подписью</ui-button
      >
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { postApi, downloadBase64FilePdf } from "../../run";

import { useStore } from "vuex";
const store = useStore();

const props = defineProps({
  uid: String,
  getFile: {
    type: Function,
    default: () => false,
  },
  title: {
    type: String,
    default: "No Name",
  },
  setStatus: {
    type: Function,
  },
});

const error = ref(null);
const loading = ref(null);

const getPrint = async () => {
  error.value = null;
  loading.value = true;
  await props
    .getFile()
    .then((res) => {
      if (res.error) {
        error.value = res;
      } else {
        downloadBase64FilePdf(res, props.title);
      }
    })
    .finally(() => {
      loading.value = false;
    });
};

const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

const send = async () => {
  loading.value = true;

  const base64Files = await Promise.all(
    files.value.map(async (file) => ({
      name: file.name,
      content: await fileToBase64(file),
    }))
  );

  postApi("/sendFile", {
    UID: props.uid,
    base64Files: JSON.stringify(base64Files),
  })
    .then((res) => {
      if (res.error) {
        error.value = res;
      }
      if (res.status > 0) props.setStatus(res.status);
    })
    .finally(() => {
      loading.value = false;
    });
};

const errorSize = ref(null);
const fileInput = ref(null);
const files = ref([]);
const maxSize = 10 * 1024 * 1024;

const totalSize = computed(() => {
  return files.value.reduce((sum, file) => sum + file.size, 0);
});

const handleFiles = (event) => {
  errorSize.value = false;
  const newFiles = Array.from(event.target.files);
  const combined = [...files.value, ...newFiles];
  const total = combined.reduce((sum, file) => sum + file.size, 0);
  files.value = combined;
  if (total > maxSize) {
    errorSize.value = "Суммарный размер файлов превышает 10 MB";
    return;
  }
  if (fileInput.value) fileInput.value.value = "";
};

const removeFile = (index) => {
  files.value.splice(index, 1);
  if (totalSize.value < maxSize) errorSize.value = false;
};

const formatSize = (size) => {
  return (size / (1024 * 1024)).toFixed(2) + " MB";
};
</script>